import { render } from "./edge3Page.vue?vue&type=template&id=84d64a44"
import script from "./edge3Page.vue?vue&type=script&lang=js"
export * from "./edge3Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__